import { FilterOutlined } from '@ant-design/icons';
import classNames from 'classnames';
import { ReactNode, useState } from 'react';

import { Overlay, Popover } from '../../../bootstrap';
import { useComponentVisible } from '../../hooks/useComponentVisible';

import s from './Table.module.scss';

export const FilterableTableHeading = ({
  label,
  Filter,
  isFiltered,
}: {
  label: ReactNode;
  Filter: () => ReactNode;
  isFiltered: boolean;
}) => {
  const [target, setTarget] = useState<HTMLElement | null>(null);
  const { ref, isComponentVisible: isFilterOpen, setIsComponentVisible: setIsFilterOpen } = useComponentVisible(false);

  return (
    <th ref={ref}>
      <div className="d-flex align-items-center gap-1">
        {label}
        <button
          className={classNames('u-unset d-flex align-items-center', {
            'u-color-bark1': isFilterOpen,
            'u-color-willow': isFiltered,
          })}
          onClick={(event) => {
            setIsFilterOpen(!isFilterOpen);
            setTarget(event.currentTarget);
          }}
        >
          <FilterOutlined />
        </button>
      </div>

      <Overlay show={isFilterOpen} target={target} placement="bottom" container={ref} containerPadding={20}>
        <Popover className={s.filterPopover}>
          <Popover.Body>{Filter()}</Popover.Body>
        </Popover>
      </Overlay>
    </th>
  );
};
